import type { PlcManufacturerCodeLibrary } from "./types";

export const rockwellCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "rockwell",
  manufacturer_name: "Allen-Bradley / Rockwell Automation",
  codes: [
    {
      id: "rockwell-logix-t01-c01",
      manufacturer_id: "rockwell",
      series_id: "ab-controllogix",
      model: null,
      code: "T01:C01",
      code_type: "Major Fault",
      title_ar: "Logix 5000 Power-up Fault",
      description_ar: "هذا Major Fault من نوع Power-up مرتبط بفقدان/عودة الطاقة ويظهر بصيغة Type 01 Code 01.",
      symptoms: ["الكنترولر يدخل Faulted Mode بعد حدث طاقة", "OK LED ممكن يومض أحمر"],
      causes: ["فقدان طاقة أو حدث Power-up", "Power-Up Handler أو شروط الاسترجاع تحتاج مراجعة"],
      checks: [
        {
          step: 1,
          action: "افتح Controller Properties > Major Faults واقرأ Type/Code وسجل وقت الحدث.",
          expected: "الـfault واضح ومتوافق ويا سجل الطاقة.",
          faulty: "يتكرر T01:C01 بعد كل حدث غير طبيعي بالطاقة.",
        }
      ],
      solutions: ["راجع مصدر التغذية وسجل انقطاعات الطاقة.", "راجع Power-Up Handler إذا مستخدم بالمشروع."],
      severity: "عالية",
      source_title: "Rockwell Automation Logix 5000 Controller Fault Codes / Major, Minor, and I/O Faults",
      source_section: "Major fault T01:C01 - Power-up fault",
      keywords: ["Rockwell", "ControlLogix", "CompactLogix", "T01:C01", "power-up"],
    },
    {
      id: "rockwell-logix-t04-c89",
      manufacturer_id: "rockwell",
      series_id: "ab-controllogix",
      model: null,
      code: "T04:C89",
      code_type: "Major Fault",
      title_ar: "Target step غير موجود بالروتين المحدد",
      description_ar: "Major Program Fault لأن الـtarget step المطلوب غير موجود بالـroutine المحدد.",
      symptoms: ["الكنترولر يدخل Major Fault", "البرنامج يتوقف عند تنفيذ المسار المتأثر"],
      causes: ["Target step غير موجود", "تعديل بالروتين خلّى مرجع الخطوة غير صالح"],
      checks: [
        {
          step: 1,
          action: "اقرأ Major Fault وحدد الروتين والتعليمة المرتبطة.",
          expected: "الـtarget step موجود وصالح.",
          faulty: "المرجع يشير لخطوة مو موجودة.",
        }
      ],
      solutions: ["صحح مرجع الـtarget step أو منطق الروتين.", "اختبر التعديل قبل إعادة المعدة للخدمة."],
      severity: "حرجة",
      source_title: "Rockwell Automation Logix 5000 Controller Fault Codes spreadsheet",
      source_section: "Major Fault T04:C89 - Program Fault: Target step does not exist in specified routine",
      keywords: ["Rockwell", "Logix5000", "T04:C89", "program fault", "target step"],
    },  ],
};
